module.exports = __webpack_public_path__ + "static/media/239616_05big.5d8da4a7.jpg";